import React, { useEffect, useState } from "react";
import { Spin, Typography } from "antd";
import "../styles/demoformcomponent.css";
import login_btn_icon from "../assets/login_btn_icon.svg";
import { useNavigate, useSearchParams } from "react-router-dom";
import CustomModal from "../../../../components/generic/custommodal/CustomModal";
import PrimaryButton from "../../../../components/generic/buttons/PrimaryButton";

const { Title, Text } = Typography;

const DemoLoginFormComponent = () => {
  const [loading, setLoading] = useState(false);
  const location = window.location.origin;
  const [searchParams] = useSearchParams();
  const [openModal, setOpenModal] = useState(false);
  const navigate = useNavigate();

  const handleClick = () => {
    setLoading(true);
    const encodedUrl = encodeURIComponent(location + "/auth/validate");
    window.open(
      `https://pdv01.b2clogin.com/pdv01.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1_SignIn&client_id=e680e18c-1e6a-49eb-8b98-8820c4530af7&nonce=defaultNonce&redirect_uri=${encodedUrl}&scope=openid&response_type=id_token&prompt=login`,
      "_self"
    );
    setTimeout(() => {
      setLoading(false);
    }, 3000);
  };

  const handleHelpClick = () => {
    window.open(
      "https://pdv2.on.spiceworks.com/portal/registrations",
      "_blank"
    );
  };

  const handlePrimaryButtonClick = () => {
    setOpenModal(false);
    navigate("/login", { replace: true });
  };

  const footerButtons = (
    <>
      <PrimaryButton
        buttonText={"OK"}
        handleOnClick={handlePrimaryButtonClick}
      />
    </>
  );

  useEffect(() => {
    const inactivity = searchParams.get("inactivity");
    setOpenModal(Boolean(inactivity));
  }, [searchParams]);

  return (
    <>
      {!loading ? (
        <section className="demo-form">
          <div className="form-header">
            <Title level={2} className="form-title">
              Hi, Welcome
              <br />
              to the Patient Data Vault
            </Title>
            <Text className="form-sub-title">
              Your Hospice's Volunteer Program Management Solution
            </Text>
          </div>
          <div className="pdv-login-button mt-4" onClick={handleClick}>
            <div>
              <img src={login_btn_icon} alt="Azure Icon" className="pdv-icon" />
            </div>
            <span>Sign In</span>
          </div>

          <Typography
            variant="p"
            className="help-text"
            onClick={handleHelpClick}
          >
            Need Help? Click Here
          </Typography>
        </section>
      ) : (
        <Spin size="large" className="spinnerCenter" />
      )}

      <CustomModal
        closable={false}
        isModalOpen={openModal}
        footer={footerButtons}
        closeModal={setOpenModal}
      >
        <div>
          <h5 className="logout-prompt-title">Session Timed Out</h5>
          <div>
            You’ve been signed out after being inactive for a while. Please log
            in again to keep going.
          </div>
        </div>
      </CustomModal>
    </>
  );
};

export default DemoLoginFormComponent;
